import Button from "@sendsprint/ui-react/components/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@sendsprint/ui-react/shadcn/dropdown-menu";
import { sections } from "..";
import Link from "next/link";
import Typography from "@sendsprint/ui-react/components/typography";
import ChevronDownOutline from "@sendsprint/icons/svgs/ChevronDownOutline";

interface Props {
  hash: string;
  handleSetHash: (arg: string) => void;
}

const MobileAside = ({ handleSetHash, hash }: Props) => {
  const currentHash = hash.startsWith("#") ? hash.slice(1) : hash;

  return (
    <div className="ss:md:hidden">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            label={decodeURIComponent(currentHash)}
            iconRight={<ChevronDownOutline />}
            className="ss:px-0"
            variant="ghost"
          />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="ss:border-primary1-500/30! ss:right-10!">
          {sections.map((item) => (
            <DropdownMenuItem key={item} asChild>
              <Link href={`#${item}`} className="ss:block">
                <Typography>{item}</Typography>
              </Link>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default MobileAside;
